<template>
    <div class="cart__table cart-table">
        <table class="cart-table__table">
            <thead class="cart-table__head">
                <tr class="cart-table__row">
                    <th class="cart-table__column cart-table__column--image">ITEM NUMBER</th>
                    <th class="cart-table__column cart-table__column--numeral">Quantity</th>
                    <th class="cart-table__column cart-table__column--numeral">MFG Code</th>
                    <th class="cart-table__column cart-table__column--product"></th>
                    <th class="cart-table__column cart-table__column--price"></th>
                    <th class="cart-table__column cart-table__column--total"></th>
                    <th class="cart-table__column cart-table__column--remove"><img src="images/spacer.png" width="20px"></th>
                </tr>
            </thead>
            <tbody class="cart-table__body">
                <stock-order-list-item
                    v-for="(part, index) in mparts"
                    :key="index"
                    :part="part"
                    :index="index"
                    :locations="locations"
                    @update_qty="update_qty"
                    @update_item_code="changeItemCode"
                    @update_mfg_code="changeMFGCode"
                    @remove_item="remove_item">
                </stock-order-list-item>
            </tbody>
            <tfoot class="cart-table__foot">
                <tr>
                    <td colspan="6">
                        <div class="cart-table__actions">
                            <div class="cart-table__update-button cart-table__actions-stock-order-add-to-cart">
                                <button class="btn btn-sm btn-checkout" :disabled="btnAddItemEnable" @click="add_to_cart">Add Items to Cart</button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import StockOrderListItem from './StockOrderListItem';

export default {
    components: {
        StockOrderListItem
    },
    props: {
        mparts: {
            
        },
        locations: {
            
        },
        allValid: {
            type: Boolean
        }
    },
    data() {
        return {
            btnAddItemEnable: 'disabled',
        };
    },
    watch: {
        allValid(newVal){
            if (newVal == true){
                this.btnAddItemEnable = false;
            }else{
                this.btnAddItemEnable = 'disabled';
            }
        }
    },

    methods: {
        add_to_cart() {
            this.$emit('add_to_cart');
            this.btnAddItemEnable = 'disabled';
        },
        remove_item(index){
            this.$emit('remove_item', index);
        },
        update_qty(index, newQty){
            this.$emit('update_qty', index, newQty);
        },

        changeItemCode(index, newVal){
            this.$emit('update_item_code', index, newVal);
        },

        changeMFGCode(index, newVal){
            this.$emit('update_mfg_code', index, newVal);
        }
    },

    created() {
        // console.log(this.mparts);
    }
}
</script>